<template>
  <div class="v-application">
    <div id="pfo-widget-open" style="display: none;" @click.prevent="pfoWidgetOpen"/>
    <div id="pfo-widget-close" style="display: none;" @click.prevent="pfoWidgetClose"/>
    <v-btn id="pfo-widget-button" fixed fab bottom :right="isFABRight" :hidden="isLauncherHidden" class="hidden-xs-only pfo-button"
          :class="{hideBtn: isLauncherHidden}"
           @click.prevent="isOpen = !isOpen"
           :style="'bottom:'+ bottomDistance +'px;'+ fabPosition"
    >
      <img v-if="!isOpen" :src="getLogo()"  :style="{ width: fabLogoSize + 'px', height: fabLogoSize + 'px' }" /> <!--:width="{fabLogoSize}" :height="{fabLogoSize}" -->
      <v-icon v-else color="white" :style="'background-color:'+ appColor +'; border-radius: 50%'" class="close-icon pfo-button">close</v-icon>
    </v-btn>

    <v-btn id="pfo-widget-button-mobile" v-if="!isOpen" fixed fab :large="isFABLarge" bottom right :color="appColor" :class="{hideBtn: isMobileLauncherHidden}" :hidden="isMobileLauncherHidden" class="hidden-sm-and-up pfo-button-mobile"
           @click.prevent="isOpen = !isOpen"
           :style="'bottom:'+ bottomDistanceMobile +'px; background-color:'+ appColor +' !important;'+ fabPositionMobile"
    >
      <img :src="getLogo()"  :style="{ width: fabLogoSizeMobile + 'px', height: fabLogoSizeMobile + 'px' }"/>

    </v-btn>

    <v-main>
      <PanelPerfumist
              :isOpen="isOpen"
              :isMobile="isMobile"
              :isRTL="isRTL"
              :locale="locale"
              :country="country"
              @close-panel="closePanel"
              @show-ingredients2="showIngredients3"
              @set-settings="setSettings"
      />

    </v-main>

  </div>
</template>

<script>
  import PanelPerfumist from './PanelPerfumist'

  export default {
    name: 'Launcher',
    components: {PanelPerfumist},
    data() {
      return {
        locale: null,
        country: null,
        isOpen: process.env.VUE_APP_IS_WEBAPP == "true" ? true : false,
        isMobile: false,
        isLauncherHidden: false,
        isMobileLauncherHidden: false,
        isRTL: false,
        bottomSheet: false,
        currentUrl: null,
        isPerfumeUrl: false,
        forceFrench: false,
        pfologourl: null,
        pfologopng: null,
        bottomDistance: 0,
        bottomDistanceMobile: 0,
        fabPosition: process.env.VUE_APP_ISFABRIGHT == "true" ? "right: 20px" : "left: 20px",
        fabPositionMobile: process.env.VUE_APP_ISFABRIGHT == "true" ? "right: 20px" : "left: 20px",
        fabLogoSize: "72",
        fabLogoSizeMobile: "72"
      }
    },
    props: {
      isFABRight: {
        type: Boolean,
        default: () => false
      },
      isFABLarge: {
        type: Boolean,
        default: () => true
      }
    },
    computed: {
      appColor() {
        return process.env.VUE_APP_COLOR
      },
      appTitle() {
        return process.env.VUE_APP_TITLE
      }
    },
    created() {
      if (process.env.VUE_APP_HIDE_LAUNCHER_DESKTOP==="true" || process.env.VUE_APP_IS_WEBAPP == "true") {
        this.isLauncherHidden = true
      }

      console.log(this.isLauncherHidden)

      if (process.env.VUE_APP_HIDE_LAUNCHER_MOBILE==="true" || process.env.VUE_APP_IS_WEBAPP == "true") {
        this.isMobileLauncherHidden = true
      }

      this.fabLogoSize = process.env.VUE_APP_LOGO_SIZE
      this.fabLogoSizeMobile = process.env.VUE_APP_LOGO_SIZE_MOBILE

      this.bottomDistance = (Number(process.env.VUE_APP_BOTTOM_DISTANCE)+15)
      this.bottomDistanceMobile = (Number(process.env.VUE_APP_BOTTOM_DISTANCE_MOBILE)+15)


      if (process.env.VUE_APP_IS_WEBAPP == "false" && localStorage.getItem('isOpen')) {
        this.isOpen = JSON.parse(localStorage.getItem('isOpen'))
      }
      this.isMobile=this.$vuetify.breakpoint.xsOnly || process.env.VUE_APP_IS_WEBAPP == "false"

      let currentUrl = window.location.pathname
      

      if (currentUrl.split('/')[1] === "en") {
        localStorage.setItem('langPFO', JSON.stringify('en'))
      }
      else if (currentUrl.split('/')[1] === "fr" || (this.forceFrench)) {
        localStorage.setItem('langPFO', JSON.stringify('fr'))
      }
      else if (currentUrl.split('/')[1] === "ar") {
        localStorage.setItem('langPFO', JSON.stringify('ar'))
        this.isRTL = true
      }
      else if (currentUrl.split('/')[1] === "ko") {
        localStorage.setItem('langPFO', JSON.stringify('ko'))
      }
      else if (currentUrl.split('/')[1] === "it") {
        localStorage.setItem('langPFO', JSON.stringify('it'))
      }
      else if (currentUrl.split('/')[1] === "de") {
        localStorage.setItem('langPFO', JSON.stringify('de'))
      }
      else if (currentUrl.split('/')[1] === "jp") {
        localStorage.setItem('langPFO', JSON.stringify('ja'))
      }
      else if (currentUrl.split('/')[1] === "pt") {
        localStorage.setItem('langPFO', JSON.stringify('pt'))
      }
      else if (currentUrl.split('/')[1] === "sv") {
        localStorage.setItem('langPFO', JSON.stringify('sv'))
      }
      else {
        this.getLanguageFromSite()
      }

      if (process.env.VUE_APP_OVERRIDE_LOCALE === "true") {
        if (JSON.parse(localStorage.getItem('settingsPFO'))===true) {
          this.locale = JSON.parse(localStorage.getItem('langSET'))
          localStorage.setItem('langPFO', JSON.stringify(this.locale))

          this.country = JSON.parse(localStorage.getItem('countrySET'))
        }
      }
      else {
        if (localStorage.getItem('langPFO')) {
          this.locale = JSON.parse(localStorage.getItem('langPFO'))
        }

        if (localStorage.getItem('countryPFO')) {
          this.country = JSON.parse(localStorage.getItem('countryPFO'))
        }
      }


      // finally set the locale
      localStorage.setItem('localePFO', JSON.stringify(JSON.parse(localStorage.getItem('langPFO'))))

    },
    watch: {
      isOpen(newState) {
        localStorage.setItem('isOpen', JSON.stringify(newState))
        if(newState) {
          if (typeof window._paq !== 'undefined') { window._paq.push(['trackEvent','PFO Widget','Opened', 'Language: '+JSON.parse(localStorage.getItem('langPFO'))]) }
        }
        else {
          if (typeof window._paq !== 'undefined') { window._paq.push(['trackEvent','PFO Widget','Closed', 'Language: '+JSON.parse(localStorage.getItem('langPFO'))]) }
        }
      }
    },
    methods:{
      __mounted() {
        if (typeof window._paq !== 'undefined') {
          window._paq.push(['trackEvent', 'PFO Widget','Display', 'Language: '+JSON.parse(localStorage.getItem('langPFO'))])
        }
      },
      getLogo() {
        if (this.locale==='en') return require(`@/assets/`+process.env.VUE_APP_LOGO_INLINE_EN)
        if (this.locale==='fr') return require(`@/assets/`+process.env.VUE_APP_LOGO_INLINE_FR)
        if (this.locale==='es') return require(`@/assets/`+process.env.VUE_APP_LOGO_INLINE_ES)
        if (this.locale==='de') return require(`@/assets/`+process.env.VUE_APP_LOGO_INLINE_DE)
        if (this.locale==='ja') return require(`@/assets/`+process.env.VUE_APP_LOGO_INLINE_JP)
        if (this.locale==='ar') return require(`@/assets/`+process.env.VUE_APP_LOGO_INLINE_AR)
        if (this.locale==='pt') return require(`@/assets/`+process.env.VUE_APP_LOGO_INLINE_PT)
        if (this.locale==='sv') return require(`@/assets/`+process.env.VUE_APP_LOGO_INLINE_SV)
        if (this.locale==="ru") return require(`@/assets/`+process.env.VUE_APP_LOGO_INLINE_RU)
        if (this.locale==="tr") return require(`@/assets/`+process.env.VUE_APP_LOGO_INLINE_TR)
        if (this.locale==="ms") return require(`@/assets/`+process.env.VUE_APP_LOGO_INLINE_MS)
        if (this.locale==="it") return require(`@/assets/`+process.env.VUE_APP_LOGO_INLINE_IT)
        if (this.locale==="ko") return require(`@/assets/`+process.env.VUE_APP_LOGO_INLINE_KO)
        if (this.locale==="nl") return require(`@/assets/`+process.env.VUE_APP_LOGO_INLINE_NL)
        return require(`@/assets/`+process.env.VUE_APP_LOGO_INLINE_EN)
      },
      pfoWidgetOpen() {
        this.isOpen = true
      },
      pfoWidgetClose() {
         if (process.env.VUE_APP_IS_WEBAPP == "false")
            this.isOpen = false
      },
      closePanel() {
         if (process.env.VUE_APP_IS_WEBAPP == "false")
          this.isOpen = false
      },
      closeParent() {
           if (process.env.VUE_APP_IS_WEBAPP == "false")
            this.isOpen = false
      },
      showIngredients3() {
          if (process.env.VUE_APP_IS_WEBAPP == "false")
            this.isOpen = false
      },
      getLanguageFromSite: function () {
        let htmlStdLang = document.documentElement.lang
        let htmlXmlLang = document.getElementsByTagName('html')[0].getAttribute('xml:lang')
        let htmlLang =  null

        if (htmlStdLang === "") { htmlLang = htmlXmlLang }
        else { htmlLang = htmlStdLang }

        var userLang = navigator.language || navigator.userLanguage
        // fetching locale from browser instead, and overiding it
        if (userLang) {
          htmlLang = userLang
        }

        if ((htmlLang === "en-US") || (htmlLang === "en")|| htmlLang.substring(0,2) == 'en') {
          localStorage.setItem('langPFO', JSON.stringify('en'))
          localStorage.setItem('countryPFO', JSON.stringify('UK'))
        } else if ((htmlLang === "fr-FR") || (htmlLang === "fr")|| htmlLang.substring(0,2) == 'fr') {
          localStorage.setItem('langPFO', JSON.stringify('fr'))
          localStorage.setItem('countryPFO', JSON.stringify('FR'))
        } else if ((htmlLang === "ko-KO") || (htmlLang === "ko")|| htmlLang.substring(0,2) == 'ko') {
          localStorage.setItem('langPFO', JSON.stringify('ko'))
          localStorage.setItem('countryPFO', JSON.stringify('KO'))
        } else if (htmlLang === "ar"|| htmlLang.substring(0,2) == 'ar') {
          localStorage.setItem('langPFO', JSON.stringify('ar'))
          localStorage.setItem('countryPFO', JSON.stringify('SA'))
          this.isRTL = true
        } else if (htmlLang === "es" || htmlLang.substring(0,2) == 'es') {
          localStorage.setItem('langPFO', JSON.stringify('es'))
          localStorage.setItem('countryPFO', JSON.stringify('ES'))
        }
        else if (htmlLang === "de"|| htmlLang.substring(0,2) == 'de') {
          localStorage.setItem('langPFO', JSON.stringify('de'))
          localStorage.setItem('countryPFO', JSON.stringify('DE'))
        }
        else if ((htmlLang === "ja-JP") || (htmlLang === "jp") || (htmlLang === "ja")) {
          localStorage.setItem('langPFO', JSON.stringify('ja'))
          localStorage.setItem('countryPFO', JSON.stringify('JP'))
        }
        else if ((htmlLang === "pt-BR") || (htmlLang === "pt")) {
          localStorage.setItem('langPFO', JSON.stringify('pt'))
          localStorage.setItem('countryPFO', JSON.stringify('BR'))
        }
        else if ((htmlLang === "sv-SE") || (htmlLang === "sv") || (htmlLang === "sv-se")) {
          localStorage.setItem('langPFO', JSON.stringify('sv'))
          localStorage.setItem('countryPFO', JSON.stringify('SE'))
        } else if (htmlLang === "ru" || htmlLang.substring(0,2) == 'ru') {
          localStorage.setItem('langPFO', JSON.stringify('ru'))
          localStorage.setItem('countryPFO', JSON.stringify('RU'))
        } else if (htmlLang === "tr" || htmlLang.substring(0,2) == 'tr') {
          localStorage.setItem('langPFO', JSON.stringify('tr'))
          localStorage.setItem('countryPFO', JSON.stringify('TR'))
        } else if (htmlLang === "ms" || htmlLang.substring(0,2) == 'ms') {
          localStorage.setItem('langPFO', JSON.stringify('ms'))
          localStorage.setItem('countryPFO', JSON.stringify('MS'))
        }
        else if ((htmlLang === "ru-RU") || (htmlLang === "ru")) {
          localStorage.setItem('langPFO', JSON.stringify('ru'))
          localStorage.setItem('countryPFO', JSON.stringify('RU'))
        }
        else if ((htmlLang === "tr-TR") || (htmlLang === "tr") || (htmlLang === "tr-tr")) {
          localStorage.setItem('langPFO', JSON.stringify('tr'))
          localStorage.setItem('countryPFO', JSON.stringify('TR'))
        }
        else if ((htmlLang === "ms-MS") || (htmlLang === "ms")) {
          localStorage.setItem('langPFO', JSON.stringify('ms'))
          localStorage.setItem('countryPFO', JSON.stringify('MS'))
        }
        else if ((htmlLang === "it-IT") || (htmlLang === "it")) {
          localStorage.setItem('langPFO', JSON.stringify('it'))
          localStorage.setItem('countryPFO', JSON.stringify('IT'))
        }
        else if ((htmlLang === "ko-KR") || (htmlLang === "ko") || htmlLang.substring(0,2) == 'ko') {
          localStorage.setItem('langPFO', JSON.stringify('ko'))
          localStorage.setItem('countryPFO', JSON.stringify('KO'))
        }
        else if ((htmlLang === "nl-NL") || (htmlLang === "nl") || htmlLang.substring(0,2) == 'nl') {
          localStorage.setItem('langPFO', JSON.stringify('nl'))
          localStorage.setItem('countryPFO', JSON.stringify('NL'))
        }
        else {
          localStorage.setItem('langPFO', JSON.stringify('en'))
          localStorage.setItem('countryPFO', JSON.stringify('UK'))
        }

      },
      setSettings() {
        if (process.env.VUE_APP_OVERRIDE_LOCALE === "true") {
          if (JSON.parse(localStorage.getItem('settingsPFO'))===true) {
            this.locale = JSON.parse(localStorage.getItem('langSET'))
            this.country = JSON.parse(localStorage.getItem('countrySET'))
          }
        }
        else {
          if (localStorage.getItem('langPFO')) {
            this.locale = JSON.parse(localStorage.getItem('langPFO'))
          }

          if (localStorage.getItem('countryPFO')) {
            this.country = JSON.parse(localStorage.getItem('countryPFO'))
          }
        }
      },
      setMultilingue: function () {
        if (process.env.VUE_APP_OVERRIDE_LOCALE === "true") {
          localStorage.setItem('langPFO', JSON.stringify('fr'))
          /*
          if (JSON.parse(localStorage.getItem('localeCode')) === 'fr') {
            localStorage.setItem('locale', JSON.stringify(false))
            localStorage.setItem('langPFO', JSON.stringify('fr'))
          }
          else if (JSON.parse(localStorage.getItem('localeCode')) === 'en') {
            localStorage.setItem('locale', JSON.stringify('en'))
            localStorage.setItem('langPFO', JSON.stringify('en'))
          }
          else if (JSON.parse(localStorage.getItem('localeCode')) === 'de') {
            localStorage.setItem('locale', JSON.stringify('de'))
            localStorage.setItem('langPFO', JSON.stringify('de'))
          }
          else if (JSON.parse(localStorage.getItem('localeCode')) === 'it') {
            localStorage.setItem('locale', JSON.stringify('it'))
            localStorage.setItem('langPFO', JSON.stringify('it'))
          }
          else if (JSON.parse(localStorage.getItem('localeCode')) === 'es') {
            localStorage.setItem('locale', JSON.stringify('es'))
            localStorage.setItem('langPFO', JSON.stringify('es'))
          }
          else if (JSON.parse(localStorage.getItem('localeCode')) === 'ja') {
            localStorage.setItem('locale', JSON.stringify('jp'))
            localStorage.setItem('langPFO', JSON.stringify('jp'))
          }
          else if (JSON.parse(localStorage.getItem('localeCode')) === 'ko') {
            localStorage.setItem('locale', JSON.stringify('ko'))
            localStorage.setItem('langPFO', JSON.stringify('ko'))
          }
          else if (JSON.parse(localStorage.getItem('localeCode')) === 'ar') {
            localStorage.setItem('locale', JSON.stringify('ar'))
            localStorage.setItem('langPFO', JSON.stringify('ar'))
          }
          */
        }
      }

    }
  }
</script>
<style>
  /* Enter and leave animations can use different */
  /* durations and timing functions.              */

  .hideBtn {
    display: none !important;
  }
  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .pfo-logobutton-img {
    height: 30px !important;
  }
  .pfo-button {
    border-style: none !important;
    border-radius: 50% !important;
    z-index: 2000000000000000 !important;
  }
  pfo-button-mobile {
    border-style: none !important;
    border-radius: 50% !important;
    bottom: 90px;
  }
  .close-icon {
    display: inline-flex !important;
  }
  .pfo-logo-btn {
    color: #ffffff;
  }

  /* ---------------------------- */
  /* Color RGB to change manually */
  /* ---------------------------- */
  .v-btn >>> button:hover {
    background-color: rgba(191, 30, 46, 0.5) !important;
  }
  .v-btn >>> v-icon {
    display: inline-flex !important;
    background-color: #BF1E2E !important;
  }
  .v-btn:hover:before, .v-btn:focus:before {
    background-color: rgba(191, 30, 46,0.5) !important;
    background: initial;
  }

  #pfo-widget-button-mobile {
    display: flex;
  }


</style>
<style lang="scss">
  .pfo-button-mobile {
    /*bottom: 65px !important;*/
    z-index: 2147483647 !important;
  }
</style>